import React from 'react';
import { useDispatch } from 'react-redux';

import {
  COMMENT_VIABILITY,
  TECH_MODERN_TEMPLATE_NAME,
} from '../../../utils/const';
import SectionHeader from '../../../components/SectionHeader';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';

const ViabilityTech = ({
  data: { description },
  locales: { portfolio },
  backgroundSection,
  colorPaletteNumber,
}) => {
  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  return (
    <div
      className="viability-tech relative"
      style={{ background: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_VIABILITY} />
      <SectionHeader
        templateName={TECH_MODERN_TEMPLATE_NAME}
        title={portfolio.viability.newSectionName}
        description={description}
        onChange={(e) =>
          updateSectionField({
            sectionName: 'viability',
            field: 'description',
            name: 'viabilityText',
            value: e.target.value,
          })
        }
        portfolio={portfolio}
        colorPaletteNumber={colorPaletteNumber}
      />
    </div>
  );
};

export default ViabilityTech;
